export default [
	{
		brand: "dejun",
		card: 11,
		name: "Up Dejun",
		order: 1,
		perso: true,
	},
	{
		brand: "family",
		card: 122,
		name: "Up Family",
		order: 2,
		perso: true,
	},
	{
		brand: "cadou",
		card: 123,
		name: "Up Cadou",
		order: 2,
		perso: true,
	},
];
